import { CenteredStyle } from '../../components'

export default {
  title: 'Centered',
  value: 'centered',
  component: CenteredStyle
}
